import { PricingIllustrationContainer } from './styled';
import type { PlanType } from '@simplywallst/services';
import { useCloudflareImage, getStaticUrl } from '@/hooks/useCloudflareImage';

interface Props {
  planType: PlanType;
}

type ValidPlanType = Exclude<PlanType, ''>;

export const PlanIllustration = ({ planType }: Props) => {
  const freeBearSrc = useCloudflareImage({
    src: getStaticUrl('free-bear.png'),
    width: 208,
  });
  const premiumBearSrc = useCloudflareImage({
    src: getStaticUrl('premium-bear.png'),
    width: 208,
  });
  const unlimitedBearSrc = useCloudflareImage({
    src: getStaticUrl('unlimited-bear.png'),
    width: 208,
  });

  const TierBearMapping: Record<ValidPlanType, string> = {
    free: freeBearSrc,
    premium: premiumBearSrc,
    unlimited: unlimitedBearSrc,
    advisor: unlimitedBearSrc,
  };

  const illustration = TierBearMapping[planType];
  if (!illustration) return null;
  return (
    <PricingIllustrationContainer
      alt="bear-illustration"
      srcSet={illustration}
    />
  );
};
